//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod

const PostShippingPerformanceUpdate = (data: any) =>
    request({
        url: ApiURL.Command.UpdateShippingPerformance,
        method: RequestType.POST,
        data: data,
    });

const ShippingPerformanceCommand = {
    PostShippingPerformanceUpdate,
};

export default ShippingPerformanceCommand;
